import {Component} from '@angular/core';
/**
 * \@title Expansion panel as accordion
 */
export class ExpansionStepsExample {
  step = 0;
/**
 * @param {?} index
 * @return {?}
 */
setStep(index: number) {
    this.step = index;
  }
/**
 * @return {?}
 */
nextStep() {
    this.step++;
  }
/**
 * @return {?}
 */
prevStep() {
    this.step--;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'expansion-steps-example',
  templateUrl: 'expansion-steps-example.html',
  styleUrls: ['expansion-steps-example.css']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ExpansionStepsExample_tsickle_Closure_declarations() {
/** @type {?} */
ExpansionStepsExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ExpansionStepsExample.ctorParameters;
/** @type {?} */
ExpansionStepsExample.prototype.step;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
